module.exports = __webpack_public_path__ + "static/img/kehu.d152567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kehu.png
// module id = lNI5
// module chunks = 1